module.exports = __webpack_public_path__ + "static/media/card-lock-silver.817ec9f4.svg";